export const SITE_CONFIG = {
  name: 'Evry Health',
  url: 'https://www.evryhealth.com',
  defaultOgImage: 'https://www.evryhealth.com/og-image.png',
  twitterCard: 'summary_large_image',
}

export const PAGE_SEO = {
  '': {
    title: 'Evry Health | Modern Health Insurance for Texas Employers & Members',
    description:
      'Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.',
    ogDescription:
      'Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.',
    twitterTitle: 'Evry Health',
    twitterDescription: 'Modern health insurance for Texas employers and members.',
  },
  'admission-notification': {
    title: 'Inpatient Admission Notification | Evry Health',
    description:
      'How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.',
    ogDescription: 'How to submit inpatient admission notifications to Evry Health.',
    twitterTitle: 'Admission Notification | Evry Health',
    twitterDescription: 'Submit inpatient admission notifications to Evry Health.',
  },
  careers: {
    title: 'Careers at Evry Health | Join Our Team',
    description:
      "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
    twitterTitle: 'Careers at Evry Health',
    twitterDescription: 'Explore open roles at Evry Health in Dallas, Texas.',
  },
  'community-resources': {
    title: 'Texas Community Resources for Members | Evry Health',
    description:
      'A curated list of local community, health, food, and legal resources across Texas for Evry Health members.',
    twitterTitle: 'Texas Community Resources | Evry Health',
    twitterDescription:
      'Community, health, food, and legal resources for Evry Health members in Texas.',
  },
  'contact-us': {
    title: 'Contact Evry Health | Get a Quote',
    description:
      'Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.',
    ogDescription:
      'Get in touch with Evry Health for plan quotes, member support, or general questions.',
    twitterTitle: 'Contact Evry Health',
    twitterDescription: 'Get a quote or ask us anything. Call 1-855-579-3879.',
  },
  faqs: {
    title: 'Frequently Asked Questions | Evry Health',
    description:
      'Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.',
    twitterDescription: 'Answers to common questions about Evry Health plans and coverage.',
  },
  forms: {
    title: 'Forms & Notices | Evry Health',
    description: 'Download member and provider forms, notices, and resources from Evry Health.',
    twitterDescription: 'Download forms and notices from Evry Health.',
  },
  fwa: {
    title: 'Report Fraud, Waste & Abuse | Evry Health',
    description:
      'How Evry Health members and providers can report suspected fraud, waste, or abuse.',
    twitterDescription: 'Report suspected fraud, waste, or abuse to Evry Health.',
  },
  heartwalk: {
    title: 'PPN Heartwalk 2026 | Evry Health',
    description:
      'Walked the PPN Heartwalk? Learn how to claim your $200 Evry Rewards milestone and explore the benefits in your Evry Health plan.',
    noindex: true,
  },
  'how-we-compare': {
    title: 'How Evry Health Compares | Plan Comparison',
    description:
      'Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.',
    ogDescription:
      'Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.',
    twitterTitle: 'How Evry Health Compares',
    twitterDescription: 'Compare Evry Health plans against traditional carriers.',
  },
  'how-we-do-it': {
    title: 'How Evry Health Works | Built for Modern Workforces',
    description:
      'Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.',
    twitterTitle: 'How Evry Health Works',
    twitterDescription: 'Built for the modern business and the mobile workforce.',
  },
  'join-the-evry-network': {
    title: 'Join the Evry Health Provider Network',
    description:
      'Apply to join the Evry Health provider network. Faster payments. Transparent terms.',
    twitterTitle: 'Join the Evry Health Network',
    twitterDescription: 'Apply to join the Evry Health provider network.',
  },
  login: {
    title: 'Sign In | Evry Health',
    description: 'Sign in to the Evry Health member portal.',
    noindex: true,
  },
  'meet-your-new-team': {
    title: 'Meet Your Evry Health Care Team',
    description:
      'Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.',
    ogDescription:
      'Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.',
    twitterDescription:
      'A dedicated team of nurses, nutritionists, and doctors — included at no extra cost.',
  },
  members: {
    title: 'Member Registration | Evry Health',
    description: 'Register for your Evry Health member portal account.',
    noindex: true,
  },
  mobileapp: {
    title: 'Evry Health Mobile App | Manage Your Plan On the Go',
    description:
      'Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.',
    ogDescription:
      'Download the Evry Health mobile app to view your ID card, find providers, and message your care team.',
    twitterTitle: 'Evry Health Mobile App',
    twitterDescription: 'Manage your health plan on the go with the Evry Health app.',
  },
  news: {
    title: 'News & Press | Evry Health',
    description: 'The latest news, press releases, and announcements from Evry Health.',
    twitterDescription: 'The latest news and announcements from Evry Health.',
  },
  'non-discrimination-policy': {
    title: 'Non-Discrimination Policy | Evry Health',
    description:
      "Evry Health's commitment to non-discrimination and language assistance for members.",
    twitterDescription: 'Non-discrimination and language assistance for all members.',
  },
  'our-story': {
    title: 'Our Story | Evry Health',
    description:
      "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
    ogDescription:
      "We're on a mission to build the health insurance company we've always wanted for ourselves.",
    twitterDescription: "Building the health insurance company we've always wanted.",
  },
  partners: {
    title: 'Partners | Evry Health',
    description:
      'The partners and providers Evry Health works with to deliver modern health insurance.',
    twitterDescription: 'Partners and providers delivering modern health insurance.',
  },
  'prior-auth-list-updates': {
    title: 'Prior Authorization List Updates | Evry Health',
    description: 'Recent updates to the Evry Health prior authorization list for providers.',
    twitterDescription: 'Recent updates to the prior authorization list for providers.',
  },
  'prior-auth-tool': {
    title: 'Prior Authorization Tool | Evry Health for Providers',
    description:
      'Look up whether a procedure requires prior authorization with Evry Health.',
    twitterTitle: 'Prior Authorization Tool | Evry Health',
    twitterDescription: 'Check if prior authorization is required for a procedure.',
  },
  'prior-authorization': {
    title: 'Prior Authorization | Evry Health for Providers',
    description:
      'Information for providers on which procedures require prior authorization with Evry Health.',
    ogDescription: 'Provider resources for prior authorization with Evry Health.',
    twitterTitle: 'Prior Authorization | Evry Health',
    twitterDescription: 'Provider resources for prior authorization with Evry Health.',
  },
  'prior-authorization-request': {
    title: 'Submit a Prior Authorization Request | Evry Health for Providers',
    description:
      'Submit the Texas Standard Prior Authorization Request Form to Evry Health online, attach clinical documents, and get your case reference number right away.',
    ogDescription:
      'Submit a prior authorization request to Evry Health online and get your case reference number right away.',
    twitterTitle: 'Submit a Prior Authorization Request | Evry Health',
    twitterDescription:
      'Submit a prior authorization request online and get your case reference number right away.',
  },
  'privacy-policy': {
    title: 'Privacy Policy | Evry Health',
    description:
      'How Evry Health collects, uses, and protects your personal and health information.',
    twitterDescription: 'How Evry Health protects your personal and health information.',
  },
  providerdirectory: {
    title: 'Provider Directory | Evry Health',
    description: 'Find in-network providers with the Evry Health provider directory.',
    noindex: true,
  },
  'request-to-join': {
    title: 'Request to Join | Evry Health Network',
    description:
      'Submit a request to join the Evry Health provider network. Simple application process.',
    ogDescription: 'Submit a request to join the Evry Health provider network.',
    twitterTitle: 'Request to Join | Evry Health',
    twitterDescription: 'Join the Evry Health provider network.',
  },
  'request-provider-addition': {
    title: 'Request Provider Addition | Evry Health',
    description:
      'Request a provider to be added to the Evry Health network. Enter an NPI and we help fill in their practice details.',
    ogDescription: 'Request a provider to be added to the Evry Health network.',
    twitterTitle: 'Request Provider Addition | Evry Health',
    twitterDescription: 'Request a provider for the Evry Health network.',
  },
  'retrospective-reviews': {
    title: 'Retrospective Reviews | Evry Health for Providers',
    description:
      'Learn how Evry Health determines coverage after treatment has been provided.',
    twitterTitle: 'Retrospective Reviews | Evry Health',
    twitterDescription: 'How Evry Health determines coverage after treatment.',
  },
  'eligibility-verification': {
    title: 'Eligibility Verification | Evry Health for Providers',
    description:
      "Providers can verify a member's current Evry Health eligibility and in-network status in real time.",
    ogDescription:
      'Real-time member eligibility and in-network status verification for Evry Health providers.',
    twitterTitle: 'Eligibility Verification | Evry Health',
    twitterDescription:
      'Verify member eligibility and in-network status in real time.',
  },
  'claims-verification': {
    title: 'Claims Verification | Evry Health for Providers',
    description:
      'Providers can check the status of a submitted Evry Health claim and view the explanation of payment in real time.',
    ogDescription:
      'Real-time claim status and explanation of payment lookup for Evry Health providers.',
    twitterTitle: 'Claims Verification | Evry Health',
    twitterDescription:
      'Check claim status and explanation of payment in real time.',
  },
  'prior-auth-status': {
    title: 'Prior Authorization Status | Evry Health for Providers',
    description:
      'Providers can check the prior authorizations on file for an Evry Health member that their NPI appears on.',
    ogDescription:
      'Check prior authorization status, determination and approved procedure lines for Evry Health members.',
    twitterTitle: 'Prior Authorization Status | Evry Health',
    twitterDescription:
      'Check the prior authorizations on file for an Evry Health member.',
  },
  rewards: {
    title: 'Member Rewards | Evry Health',
    description: 'Earn rewards for staying healthy as an Evry Health member.',
    twitterDescription: 'Earn rewards for staying healthy with Evry Health.',
  },
  terms: {
    title: 'Terms of Use | Evry Health',
    description: 'Terms of use for the Evry Health website and digital services.',
    twitterDescription: 'Terms of use for Evry Health website and services.',
  },
  'virtual-care': {
    title: '$0 Virtual Care & Telehealth | Evry Health',
    description:
      'Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.',
    twitterDescription: 'Talk to a board-certified physician 24/7 for $0.',
  },
  'why-choose-evry': {
    title: 'Why Choose Evry Health | Texas Health Insurance',
    description:
      'See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.',
    twitterTitle: 'Why Choose Evry Health',
    twitterDescription:
      'See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth.',
  },
}

export function getPageSeo(slug) {
  const page = PAGE_SEO[slug] || {}
  const title = page.title || SITE_CONFIG.name
  const description = page.description || ''
  const ogTitle = page.ogTitle || title
  const ogDescription = page.ogDescription || description
  const ogImage = page.ogImage || SITE_CONFIG.defaultOgImage
  const twitterTitle = page.twitterTitle || ogTitle
  const twitterDescription = page.twitterDescription || ogDescription
  const twitterImage = page.twitterImage || ogImage
  const noindex = page.noindex || false
  const url =
    slug === ''
      ? `${SITE_CONFIG.url}/`
      : `${SITE_CONFIG.url}/${slug}`

  return {
    title,
    description,
    url,
    ogTitle,
    ogDescription,
    ogImage,
    twitterTitle,
    twitterDescription,
    twitterImage,
    noindex,
  }
}
